<template>
    <div class="ur-action-bar ur-action-bar__default-zone">
        <slot/>
        <div class="ur-action-bar__alternative-zone">
            <slot name="left"/>
        </div>
    </div>
</template>

<script>
export default {
    name:"urActionBar"
}

</script>
